
import axios from 'axios';
import { getAPIUrl } from '../../../Constants.ts';
import { AdminProcessRequestDto, ColumnAccessRequest, ColumnRestrictionFilter, ColumnRestrictionGroup, DistributionLogModel, GetReportParams, ReportDistributionModel, ReportModel, RequestColumnAccessDto, UpdateRequestStatusDto, UserDataPreviewResponse } from "./_model.ts";


const API_URL = getAPIUrl();

const REMOVE_ME_FROM_REPORT = `${API_URL}/values/RemoveMeFromReport`;
const GET_REPORT = `${API_URL}/values/GetReport`;
const GET_DISTRIBUTION_LIST = `${API_URL}/values/GetReportDistributionList`;
const GET_POWERBI_REPORTS = `${API_URL}/values/GetPowerBIReport`;
const UPSERT_REPORTS = `${API_URL}/values/UpsertReport`;
const UPSERT_REPORT_DISTRIBUTION = `${API_URL}/values/UpsertDistributionList`;
const DELETE_DISTRIBUTION = `${API_URL}/values/deleteDistributionList`;
const DELETE_REPORT = `${API_URL}/values/deleteReport`;
const GET_DISTRIBUTION_LOGS = `${API_URL}/values/GetReportDistributionLogs`;
const CLEAR_REPORT = `${API_URL}/values/ClearReportError`;
const GET_COLUMN_RESTRICTIONS = `${API_URL}/values/GetColumnRestrictions`;
const UPSERT_COLUMN_RESTRICTIONS = `${API_URL}/values/UpsertColumnRestrictions`;
const DELETE_COLUMN_RESTRICTIONS = `${API_URL}/values/DeleteColumnRestrictions`;
const GET_RESTRICTIONS_COLUMNS = `${API_URL}/values/GetRestrictionColumns`;
const GET_USER_COLUMN_REQUESTS = `${API_URL}/values/GetUserColumnRequests`;
const REQUEST_COLUMN_ACCESS = `${API_URL}/values/RequestColumnAccess`;
const GET_ALL_COLUMN_REQUESTS = `${API_URL}/values/GetAllColumnRequests`;
const PROCESS_COLUMN_REQUEST = `${API_URL}/values/ProcessColumnRequest`;
const UPDATE_REQUEST_STATUS = `${API_URL}/values/UpdateColumnRequestStatus`;
const GET_USER_ASSIGNED_GROUP = `${API_URL}/values/GetUserAssignedGroup`;
const GET_USER_DATA_PREVIEW_URL = `${API_URL}/values/GetUserDataPreview`;
const ADD_RESTRICTION_COLUMN = `${API_URL}/values/AddRestrictionColumn`;
const CHANGE_COLUMN_RESTRICTIONS = `${API_URL}/values/ChangeUserColumnRestrictions`;


export function GetRestrictionsColumns() {
    return axios.get<{ id: string, name: string }[]>(GET_RESTRICTIONS_COLUMNS);
}

export function GetColumnRestrictions(request: ColumnRestrictionFilter) {
    return axios.post<ColumnRestrictionGroup[]>(GET_COLUMN_RESTRICTIONS, request);
}

export function DeleteColumnRestrictions(columnRestrictionId: number) {
    return axios.get<string>(DELETE_COLUMN_RESTRICTIONS + "?columnRestrictionId=" + columnRestrictionId);
}

export function UpsertColumnRestrictions(request: ColumnRestrictionGroup) {
    return axios.post<string>(UPSERT_COLUMN_RESTRICTIONS, request);
}

export function ChangeUserColumnRestrictions(request: {
    byUser: number;
    newGroupId: number;
    userId: number
}) {
    return axios.post<string>(CHANGE_COLUMN_RESTRICTIONS, request);
}

export function RetryReport(request: { reportAutoID: number, reportID: string, workspaceID: string }) {
    return axios.post<string>(CLEAR_REPORT, request);
}

export function GetReportDistributionLogs(reportDistributionID: number) {
    return axios.get<DistributionLogModel[]>(GET_DISTRIBUTION_LOGS + "?reportDistributionID=" + reportDistributionID);
}

export function DeleteReport(reportId: string, byUser: number) {
    return axios.get<string>(DELETE_REPORT + "?reportID=" + reportId + "&byUser=" + byUser);
}

export function DeleteReportDistribution(reportDistributionID: number, byUser: number) {
    return axios.get<string>(DELETE_DISTRIBUTION + "?reportDistributionID=" + reportDistributionID + "&byUser=" + byUser);
}

export function UpsertReportDistribution(request: ReportDistributionModel) {
    return axios.post<number>(UPSERT_REPORT_DISTRIBUTION, request);
}

export function UpsertReport(request: ReportModel) {
    return axios.post<string>(UPSERT_REPORTS, request);
}

export function GetPowerBIReport(request: any) {
    return axios.post<ReportModel[]>(GET_POWERBI_REPORTS, request);
}



export function GetReport(request: GetReportParams) {
    return axios.post<ReportModel[]>(GET_REPORT, request);
}

export function RemoveMeFromReport(request: { reportAutoID: number, userID: number }) {
    return axios.post<ReportModel[]>(REMOVE_ME_FROM_REPORT, request);
}

export function GetReportDistributionList(request: { reportAutoID: number, reportID: string }) {
    return axios.post<ReportDistributionModel[]>(GET_DISTRIBUTION_LIST, request);
}



export function GetUserColumnRequests(userId: number) {
    return axios.get<ColumnAccessRequest[]>(`${GET_USER_COLUMN_REQUESTS}?userId=${userId}`);
}

export function RequestColumnAccess(request: RequestColumnAccessDto) {
    return axios.post<string>(REQUEST_COLUMN_ACCESS, request);
}


export function GetAllColumnRequests() {
    return axios.get<ColumnAccessRequest[]>(GET_ALL_COLUMN_REQUESTS);
}

export function ProcessColumnRequest(request: AdminProcessRequestDto) {
    return axios.post<string>(PROCESS_COLUMN_REQUEST, request);
}


export function UpdateColumnRequestStatus(request: UpdateRequestStatusDto) {
    return axios.post<string>(UPDATE_REQUEST_STATUS, request);
}

export function GetUserAssignedGroup(userId: number) {
    return axios.get<ColumnRestrictionGroup>(`${GET_USER_ASSIGNED_GROUP}?userId=${userId}`);
}

export function GetUserDataPreview(userId: number) {
    return axios.get<UserDataPreviewResponse>(`${GET_USER_DATA_PREVIEW_URL}?userId=${userId}`);
}

export function AddRestrictionColumn(request: { name: string, byUser: number }) {
    return axios.post<{ id: string, name: string }>(ADD_RESTRICTION_COLUMN, request);
}